import React from "react";

const industries = [
  "Healthcare",
  "Real Estate",
  "Education",
  "Manufacturing",
  "D2C Commerce",
  "SaaS & Technology"
];

function TrustBar() {
  return (
    <section className="trust-section">

      <div className="trust-container">

        <p className="trust-title">
          Built For Growth-Critical Industries
        </p>

        <div className="trust-grid">
          {industries.map((industry) => (
            <div
              key={industry}
              className="trust-pill"
            >
              {industry}
            </div>
          ))}
        </div>

      </div>

    </section>
  );
}

export default TrustBar;